/* ===== App animation & download */
class faq extends HTMLElement {
  constructor() {
    super();
    const itemIntro = this.querySelectorAll(".js-add-event");
    if (itemIntro) {
      itemIntro.forEach((item) => {
        item.addEventListener("click", this.toggleIntroItem);
      });
    }
  }

  toggleIntroItem() {
    const activeIntroItem = document.querySelector(".js-add-event.active");
    if (activeIntroItem && activeIntroItem !== this) {
      activeIntroItem.classList.toggle("active");
    }
    this.classList.toggle("active");
  }
}
customElements.define("accordion-animation", faq);
/* ===== End - App animation & download */